import { render } from "./ControlButtonGroup.vue?vue&type=template&id=314ebb4a&ts=true"
import script from "./ControlButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ControlButtonGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__